/**
 * Limit settings tab
 */
import { useReducer } from 'react';
import Text from '../../../../atoms/Text';
import Image from '../../../../atoms/Image';
import Button from '../../../../molecules/Button';
import Dealine from '../../common/Deadline';
import Slippage from '../../common/Slippage';
import SendTokens from '../../common/SendTokens';
import big_arrow_left from '../../../../assets/images/arrow_left.svg';
import {
  getInitialLimitSettingsState,
  LimitSettingsActions,
  limitSettingsReducer,
} from '../../reducers/limitSettingsReducer';
import {
  formatSettingsValue,
  validateSettingsValue,
} from '../../helpers/settingsFormatters';
import { ETabs } from '../../reducers/tradingReducer';

interface ILimitSettingsProps {
  setTab: (val: ETabs) => void;
  price: any;
  slippage: number;
  deadline: number;
  sendTokens: boolean;
  setSlippage: (val: number) => void;
  setDeadline: (val: number) => void;
  setSendTokens: (val: boolean) => void;
}

const LimitSettings = (props: ILimitSettingsProps) => {
  const {
    slippage,
    setSlippage,
    deadline,
    setDeadline,
    sendTokens,
    setSendTokens,
  } = props;

  const [state, dispatch] = useReducer(
    limitSettingsReducer,
    getInitialLimitSettingsState(slippage, deadline, sendTokens)
  );

  const onBack = () => {
    props.setTab(ETabs.Limit);
  };

  const onSave = () => {
    setSlippage(formatSettingsValue(state.slippage));
    setDeadline(formatSettingsValue(state.deadline));
    setSendTokens(state.sendTokens);

    onBack();
  };

  const handleSetSlippage = (value: string) => {
    const isValid = validateSettingsValue(value, 0, 50);
    dispatch({ type: LimitSettingsActions.SetSlippage, payload: value });
    dispatch({ type: LimitSettingsActions.SetSlippageValid, payload: isValid });
  };

  const handleSetDeadline = (value: string) => {
    const isValid = validateSettingsValue(value, 1, 30, true);
    dispatch({ type: LimitSettingsActions.SetDeadline, payload: value });
    dispatch({ type: LimitSettingsActions.SetDeadlineValid, payload: isValid });
  };

  const handleToggleSendTokens = () => {
    dispatch({ type: LimitSettingsActions.ToggleSendTokens });
  };

  const isValid = state.slippageValid && state.deadlineValid;

  return (
    <div className='limit_settings'>
      <div className='header'>
        <div className='arrow_back' onClick={onBack}>
          <Image size='s' src={big_arrow_left} />
        </div>
        <Text size={14}>Limit settings</Text>
        <div className='placeholder' />
      </div>
      <div className='container'>
        <Slippage slippage={state.slippage} setSlippage={handleSetSlippage} />
        {!state.slippageValid && (
          <Text size={10} className='not-valid text--red-600'>
            Please enter the number from 0 to 50
          </Text>
        )}
        <Dealine deadline={state.deadline} onSetDeadline={handleSetDeadline} />
        {!state.deadlineValid && (
          <Text size={10} className='not-valid text--red-600'>
            Please enter the integer number from 1 to 30
          </Text>
        )}
        <SendTokens
          sendTokens={state.sendTokens}
          toggleSendTokens={handleToggleSendTokens}
        />
      </div>

      <div className='buttons'>
        <div className='buttons__item'>
          <Button
            text='Decline'
            variant='swap_settings'
            size='m'
            action={onBack}
          />
        </div>
        <div className='buttons__item'>
          <Button
            text='Save'
            variant='primary'
            size='m'
            action={onSave}
            disabled={!isValid}
          />
        </div>
      </div>
    </div>
  );
};

export default LimitSettings;
